import { createRouter, createWebHistory } from 'vue-router'
import { userStore } from '@/store/userStore'

import LoginView from '../views/LoginView.vue'

const routes = [
  {
    path: '/',
    name: 'CatalogList',
    component: () => import('../views/CatalogList.vue')
  },
  {
    path: '/catalog/:id',
    name: 'CatalogDetail',
    component: () => import('../views/CatalogDetail.vue'),
    props: true
  },
  {
    path: '/fabric-editor',
    name: 'FabricEditor',
    component: () => import('../views/FabricEditorView.vue'),
    meta: { requiresManage: true },
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = localStorage.getItem('jwt');
  const requiresAuth = to.name !== 'Login';

  if (requiresAuth && !isAuthenticated) {
    next({ name: 'Login' });
  } else if (to.name === 'Login' && isAuthenticated) {
    next({ name: 'CatalogList' });
  } else {
    if (isAuthenticated && (!userStore.currentUser || !userStore.currentUser.role)) {
      await userStore.fetchCurrentUser();
    }
    if (to.meta.requiresManage && !userStore.canManage) {
      next({ name: 'CatalogList' });
    } else {
      next();
    }
  }
});

export default router